export default __webpack_public_path__ + "bd4f3144848fe8444ec1bd944c22e163.png";